import { render } from "./CreateOrders.vue?vue&type=template&id=3522742f&scoped=true"
import script from "./CreateOrders.vue?vue&type=script&lang=js"
export * from "./CreateOrders.vue?vue&type=script&lang=js"

import "./CreateOrders.vue?vue&type=style&index=0&id=3522742f&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3522742f"]])

export default __exports__